import { Page } from '@/components';
import routes from '@/routes';
import { Outlet } from 'react-router-dom';

const Rate = () => {
  const menu = [
    {
      title: routes.settingsMixes.name,
      to: routes.settingsMixes.path,
    },
    {
      title: routes.settingsMortgageCycleMixes.name,
      to: routes.settingsMortgageCycleMixes.path,
    },
    {
      title: routes.settingsRates.name,
      to: routes.settingsRates.path,
    },
    {
      title: routes.settingsReverseRates.name,
      to: routes.settingsReverseRates.path,
    },
    {
      title: routes.settingsReverse.name,
      to: routes.settingsReverse.path,
    },
    {
      title: routes.settingsUsers.name,
      to: routes.settingsUsers.path,
    },
  ];

  return (
    <Page
      title={routes.settings.name}
      hideHelp
      hideNews
      menu={menu}
    >
      <Outlet />
    </Page >
  );
};

export default Rate;
